var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-wrapper",class:{ 'visible': _vm.visible }},[_c('div',{staticClass:"spinner-border loader",class:{ 'loader--visible': _vm.visible },attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }